import React from 'react';
import PropTypes from 'prop-types';

import {
  FormFieldStyled,
  LabelStyled,
  InputStyled,
  IconStyled,
} from './Input.styled';

export const inputType = {
  TEXT: 'text',
  PASSWORD: 'password',
};

export const inputSize = {
  XSMALL: 'xsmall',
  SMALL: 'small',
  DEFAULT: 'default',
};

export const inputVariant = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
};

function Input({
  id,
  className,
  type,
  name,
  label,
  placeholder,
  icon,
  rounded,
  size,
  variant,
  autoComplete,
  disabled,
  ...props
}) {
  return (
    <FormFieldStyled size={size} disabled={disabled}>
      {label && (
        <LabelStyled htmlFor={id} size={size}>
          {label}
        </LabelStyled>
      )}
      {icon && <IconStyled name={icon} hasLabel={label} />}
      <InputStyled
        id={id}
        type={type}
        name={name}
        size={size}
        placeholder={placeholder}
        tabIndex={props.tabIndex}
        autoComplete={!autoComplete ? 'off' : 'true'}
        rounded={rounded}
        variant={variant}
        {...props}
        ref={props.inputRef}
        className={className}
      />
    </FormFieldStyled>
  );
}

export default Input;

Input.defaultProps = {
  type: inputType.TEXT,
  autoComplete: false,
  variant: inputVariant.PRIMARY,
  size: inputSize.DEFAULT,
};

Input.propTypes = {
  className: PropTypes.string,
  /**
   * Id of the input
   */
  id: PropTypes.string,
  /**
   * Input type
   */
  type: PropTypes.oneOf(Object.values(inputType)),
  /**
   * Form name input
   */
  name: PropTypes.string,
  /**
   * This prop shows the placeholder of the input
   */
  placeholder: PropTypes.string,
  /**
   * Allows showing an <a href="https://storybook.wikifactory.com/?path=/docs/4--page">icon
   * present on the theme</a> by name.
   */
  icon: PropTypes.string,
  /**
   * Input label
   */
  label: PropTypes.string,
  size: PropTypes.oneOf(Object.values(inputSize)),
  /**
   * Enable automatic completion by the browser
   */
  autoComplete: PropTypes.bool,
  /**
   * Disable the input
   */
  disabled: PropTypes.bool,
  /**
   * Defines different appearances for the component
   */
  variant: PropTypes.oneOf(Object.values(inputVariant)),
  inputRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Input) }),
  ]),
  tabIndex: PropTypes.number,
};
